import { useEffect, useRef } from "react";
import { Outlet } from "react-router";
import { toast } from "sonner";
import {
  useMarkNotificationSeenMutation,
  useUnseenNotificationsQuery,
} from "../queries/notification-queries";
import { NotificationItem } from "./Notification";

export default function NotificationsPoller() {
  const { data: unseen = [] } = useUnseenNotificationsQuery();
  const { mutate: markNotificationSeen } = useMarkNotificationSeenMutation();
  const activeToastsRef = useRef<Map<string, string | number>>(new Map());

  useEffect(() => {
    for (const notification of unseen) {
      if (notification.displayType !== "TOAST") continue;
      if (activeToastsRef.current.has(notification.externalId)) continue;

      const toastId = toast.custom(
        (toastId) => (
          <div className="w-96 rounded-sm border border-grey-200 bg-white shadow-lg">
            <NotificationItem
              notification={notification}
              onDismiss={() => {
                markNotificationSeen(notification.externalId);
                toast.dismiss(toastId);
                activeToastsRef.current.delete(notification.externalId);
              }}
              isUnseen={false}
              menuMode="close"
            />
          </div>
        ),
        { position: "bottom-right", duration: Infinity },
      );

      activeToastsRef.current.set(notification.externalId, toastId);
    }

    const unseenIds = new Set(unseen.map((n) => n.externalId));
    for (const [externalId, toastId] of activeToastsRef.current) {
      if (!unseenIds.has(externalId)) {
        toast.dismiss(toastId);
        activeToastsRef.current.delete(externalId);
      }
    }
  }, [unseen, markNotificationSeen]);

  return <Outlet />;
}
